import { Component } from '@angular/core';
import { NavController, NavParams, ToastController } from 'ionic-angular';
import { DIC } from '../dic';
import { GN } from '../../gn';
import { PNMaps } from '../../pan.maps';
import { BarcodeScanner } from '@ionic-native/barcode-scanner';

/**
 * Generated class for the BankpickupPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-bankpickup',
  templateUrl: 'bankpickup.html',
})
export class BankpickupPage {

  pin = ''
  forpoi = ''
  forpoiid = -1
  prednotes = []
  driverorg = 0
  corrPin = 0
  goods = ''
  corrPinPerson = ''
  corrPinPersonId = -1
  totalGoods = ''
  hederid = -1
  rbr = -1
  myLon: any
  myLat: any
  isMyPozOK = false
  corrAmount = 0
  idDB = -1

  constructor(private barcodeScanner: BarcodeScanner, public panMaps: PNMaps, public navCtrl: NavController, public navParams: NavParams, public dic: DIC, public gn: GN, public toastCtrl: ToastController) {
    if (this.gn.user.driverid + '' != '-1') {
      this.panMaps.isPozWatching = false
      this.panMaps.isMyPozOK = false
    }
  }

  ionViewDidLoad() {
    var _that = this
    if (this.gn.user.driverid + '' != '-1') {
      this.panMaps.getDriverPosition(function (_lat, _lng, _isMyPozOK) {
        _that.myLat = _lat
        _that.myLon = _lng
        _that.isMyPozOK = _isMyPozOK
      })
    }

    this.forpoi = this.navParams.get('obj').name;
    this.forpoiid = this.navParams.get('obj').id;
    this.hederid = this.navParams.get('hederid');
    this.rbr = this.navParams.get('obj').idx
    this.loadEmployeeorg()
  }

  loadPredefinedNotes() {
    var _that = this
    this.gn._Post('/api/gn/getPredNotes', { cid: this.gn.crypt(this.gn.user.ClientId) }, function (_data) {
      console.log(_data, 'daj da vidam data')
      for (let i = 0; i < _data.length; i++) {
        console.log(_data[i].employeeid, '_data[i].employeeid')
        console.log(_that.gn.user.driverid, '_that.gn.user.driverid')
        if (_data[i].employeeid == _that.gn.user.driverid || (_data[i].orgid == null && _data[i].employeeid == null) || (_that.driverorg == _data[i].orgid && _data[i].employeeid == null)) {
          _that.prednotes.push(_data[i])
        }
      }
      // _that.prednotes = _data
    })
  }

  loadEmployeeorg() {
    var _that = this
    this.gn._Post('/api/gn/getDriverOrg', { uid: this.gn.crypt(this.gn.user.UserId) }, function (_data) {
      _that.driverorg = _data[0].organisationid
      console.log(_that.driverorg, '_that.driverorg')
      _that.loadPredefinedNotes()
      // for (let i = 0; i < _data.length; i++) {
      //   if (_data[i].employeeid == _that.gn.user.UserId || (_data[i].orgid == null && _data[i].employeeid == null) || (_that.gn.user.UserGroup == _data[i].orgid && _data[i].employeeid == null)) {
      //     _that.prednotes.push(_data[i])
      //   }

      // }
      // _that.prednotes = _data
    })

  }

  confirmPin() {
    var _that = this
    this.gn._Post('/api/gn/checkBankPin', { pin: this.gn.crypt(this.pin), poiid: this.gn.crypt(this.forpoiid) }, function (_data) {
      if (_data.data.length > 0) {
        _that.corrPin = 1
        _that.corrPinPerson = _data.data[0].officialname
        _that.corrPinPersonId = _data.data[0].id
      } else {
        _that.corrPin = 0
        _that.corrPinPerson = ''
        _that.corrPinPersonId = -1
        _that.goods = ''
        let toast = _that.toastCtrl.create({ message: _that.dic.l["corrpinbank"], duration: 6000, position: 'top' });
        toast.present();
      }
    })
  }

  addGoods() {
    if (this.goods == '') return false;
    this.totalGoods += this.goods + '; '
    this.goods = ''
  }

  saveGoods() {
    if (this.goods != '') {
      this.totalGoods += this.goods + '; '
      this.goods = ''
    }
    if (this.totalGoods == '') {
      let toast = this.toastCtrl.create({ message: this.dic.l["enteramountbank"], duration: 6000, position: 'top' });
      toast.present();
    } else {
      var _that = this
      this.gn._Post('/api/insertHandingOverMoney', {
        cid: this.gn.crypt(this.gn.user.ClientId),
        poiid: this.gn.crypt(this.forpoiid),
        rbr: this.gn.crypt(this.rbr),
        hederid: this.gn.crypt(this.hederid),
        personId: this.gn.crypt(this.corrPinPersonId),
        person: this.gn.crypt(this.corrPinPerson),
        amount: this.gn.crypt(this.totalGoods),
        lat: _that.gn.crypt(this.myLat),
        lng: _that.gn.crypt(this.myLon)
      }, function (_data) {
        _that.idDB = _data.data[0].id
        _that.corrAmount = 1
      })
    }
  }

  Scan() {
    var _that = this
    this.barcodeScanner.scan().then(barcodeData => {
      // console.log('Barcode data', barcodeData.text);
      if (barcodeData.text != null && barcodeData.text != '') {
        //console.log(barcodeData, 'barcodeData')
        //alert(barcodeData.text)
        var _barcode = barcodeData.text
        _that.gn._Post('/api/updateHandingOverMoney', {
          cid: _that.gn.crypt(_that.gn.user.ClientId),
          rbr: _that.gn.crypt(_that.rbr),
          hederid: _that.gn.crypt(_that.hederid),
          person: _that.gn.crypt(_that.corrPinPerson),
          amount: _that.gn.crypt(_that.totalGoods),
          id: _that.gn.crypt(_that.idDB),
          barcode: _that.gn.crypt(_barcode),
          driverid: _that.gn.crypt(_that.gn.user.driverid)
        }, function (_data) {
          _that.navCtrl.pop()
          let toast = _that.toastCtrl.create({ message: _that.dic.l["succBank"], duration: 6000, position: 'top' });
          toast.present();
        })

        //   if (_that.order.barcode == barcodeData.text) {
        //     _that.orderSavePickuUp(barcodeData.text, 'fromBase')
        //   } else {
        //     let alert = _that.alertCtrl.create({
        //       title: 'Error!',
        //       subTitle: 'You scan wrong barcode !',
        //       buttons: ['OK']
        //     });
        //     alert.present();

        //   }
        // }
      }
    }).catch(err => {
      console.log('Error', err);
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/bankpickup/bankpickup.ts